import React, { Component } from "react";
import "./NodeModal.css";
import InfoIcon from "./InfoIcon";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
  ButtonDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";

export default class NodeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItem: this.props.activeItem,
      validationErrors: [],
      isValid: true,
      AMICheck: this.props.activeItem.ami_enabled || false,
      implementation: this.props.activeItem.implementation || "",
      convergence_layer: this.props.activeItem.convergence_layer || "",
      UnknownIPCheck: this.props.activeItem.public_ip === "Unknown",
      loading: false,
      adding: this.props.adding,
      demoMode: this.props.demoMode,
      nodeImplementationDropdownToggle: false,
      nodeCLDropdownToggle: false,
      newImplementation: false,
      newCL: false,
    };
  }

  validateInput = () => {
    const eid = this.state.activeItem.eid;
    const public_ip = this.state.activeItem.public_ip;
    const port = this.state.activeItem.port;
    const unknownIP = this.state.UnknownIPCheck;
    const implementation = this.state.activeItem.implementation ? this.state.activeItem.implementation : this.state.implementation;
    const convergence_layer = this.state.activeItem.convergence_layer ? this.state.activeItem.convergence_layer : this.state.convergence_layer;

    let errors = [];
    if (eid === "") {
      errors.push(<li key={"eid"}>Node Endpoint ID required</li>);
    } else if (!/^[0-9]*$/.test(eid)) {
      errors.push(<li key={"eid"}>Endpoint ID must be a numerical value</li>);
    }
    if (public_ip === "" && !unknownIP) {
      errors.push(<li key={"public_ip"}>Address required</li>);
    } else if (
      !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        public_ip
      ) &&
      !/^([-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*))$/.test(
        public_ip
      ) &&
      !unknownIP
    ) {
      errors.push(
        <li key={"public_ip"}>
          Entered Address is not valid (Enter IP or Domain Name)
        </li>
      );
    }
    if (port === "") {
      errors.push(<li key={"port"}>Port required</li>);
    }
    if (implementation === "") {
      errors.push(<li key={"impl"}>Implementation required</li>);
    }
    if (convergence_layer === "") {
      errors.push(<li key={"cl"}>Convergence layer required</li>);
    }
    if (
      !/^[0-9]*$/.test(port) ||
      parseInt(port) < 0 ||
      parseInt(port) > 65353
    ) {
      errors.push(
        <li key={"port"}>Entered Port is not valid, range is 0-65353</li>
      );
    }

    if (errors.length > 0) {
      this.setState({
        isValid: false,
        validationErrors: errors,
        apiModal: false,
        loading: false,
      });
      return false;
    }
    this.setState({ isValid: true, validationErrors: [] });
    return true;
  };

  handleChange = async (e) => {
    let { name, value } = e.target;
    const activeItem = { ...this.state.activeItem, [name]: value };
    await this.setState({ activeItem });

    if (this.state.apiModal) {
      this.validateInput();
    }
  };

  nodeImplementationDropdownToggle = () => {
    this.setState({nodeImplementationDropdownToggle: !this.state.nodeImplementationDropdownToggle});
    if (!this.state.newImplementation){
      this.setState({newImplementation: true})
    }
  }
  nodeCLDropdownToggle = () => {
    this.setState({nodeCLDropdownToggle: !this.state.nodeCLDropdownToggle});
    if (!this.state.newCL){
      this.setState({newCL: true})
    }
  }

  handleAMICheck = async (e) => {
    this.setState({ AMICheck: !this.state.AMICheck });
  };

  handleIPCheck = async (e) => {
    if (
      this.state.UnknownIPCheck &&
      this.state.activeItem.public_ip === "Unknown"
    ) {
      const activeItem = { ...this.state.activeItem, public_ip: "" };
      this.setState({ activeItem });
    }
    this.setState({ UnknownIPCheck: !this.state.UnknownIPCheck });
  };

  render() {
    const { toggle, getErrors, onSave, isStaff } = this.props;

    return (
      <Modal modalClassName="Modal" isOpen={true} toggle={toggle}>
        <ModalHeader>
          {this.state.adding ? " Add DTN Node " : " Edit DTN Node "}
          <button className="exit_close_button" onClick={toggle}>
            ×
          </button>
        </ModalHeader>

        <div className="val_error_area">
          <ul style={{ color: "red" }}>{this.state.validationErrors}</ul>
        </div>
        <ModalBody>
          <Form
            autoComplete="off"
            onSubmit={(event) => {
              event.preventDefault();
            }}
          >
            <FormGroup className="fg">
              <Label for="eid">Endpoint ID</Label>
              <InfoIcon
                infoText={
                  "Each DTN node will be referred to and identified by this Endpoint ID."
                }
                position={"right"}
              />
              <Input
                type="text"
                name="eid"
                value={this.state.activeItem.eid}
                onChange={this.handleChange}
                placeholder="Enter Node Endpoint ID"
                maxLength="50"
              />
            </FormGroup>
            <FormGroup className="fg">
              <Label for="public_ip">
                External Address (IP or Domain Name)
              </Label>
              <InfoIcon
                infoText={
                  "Other nodes will reach the current node via this address."
                }
                position={"right"}
              />
              <Input
                className={this.state.demoMode ? "hidden_form_input_field" : ""}
                type="text"
                name="public_ip"
                disabled={this.state.UnknownIPCheck}
                value={
                  this.state.UnknownIPCheck
                    ? "Unknown"
                    : this.state.activeItem.public_ip
                }
                onChange={this.handleChange}
                placeholder="Enter Public IP Address"
                maxLength="120"
              />
            </FormGroup>
            <div className="unknown_ip">
              <input
                type="checkbox"
                checked={this.state.UnknownIPCheck}
                onChange={this.handleIPCheck}
              />{" "}
              <Label typefor="uip">{"Uknown Address"}</Label>
              <InfoIcon
                infoText={"Uknown address for remote deployment"}
                position={"right"}
              />
            </div>
            <FormGroup className="fg">
              <Label for="port">Port</Label>
              <InfoIcon
                infoText={
                  "Port node will be accessed through, linked to Public IP."
                }
                position={"right"}
              />
              <Input
                className={this.state.demoMode ? "hidden_form_input_field" : ""}
                type="text"
                name="port"
                value={this.state.activeItem.port}
                onChange={this.handleChange}
                placeholder="Enter Port"
                maxLength="5"
              />
            </FormGroup>
            <FormGroup className="fg">
              <input
                type="checkbox"
                checked={this.state.AMICheck}
                onChange={this.handleAMICheck}
                disabled={!isStaff}
              />{" "}
              <Label typefor="eid">{"Using Spatiam's AMI?"}</Label>
              <InfoIcon
                infoText={
                  isStaff
                    ? "Check this box if you are deploying this node using Spatiam's DTN AMI"
                    : "Spatiam's DTN Amazon Machine Image is in preview, contact administrators for access"
                }
                position={"right"}
              />
            </FormGroup>
          </Form>
          <div style={{display:"flex"}}>
            <Label for="convergence_layer">Convergence Layer:</Label>
            <ButtonDropdown
            isOpen={this.state.nodeCLDropdownToggle}
            toggle={this.nodeCLDropdownToggle}
          >
            <DropdownToggle caret className="modal_action_dropdown">
              {this.state.convergence_layer === ""
                    ? "Select"
                    : this.state.convergence_layer}
            </DropdownToggle>
            <DropdownMenu right className="dropdown_menu">
              <DropdownItem
                className="dropdown_item"
                key="ltp_cl"
                onClick={() => {
                  this.setState({convergence_layer: "LTP"})
                }}
              >
                LTP
              </DropdownItem>
              <DropdownItem
                className="dropdown_item"
                key="tcp_cl"
                onClick={() => {
                  this.setState({convergence_layer: "TCP"})
                }}
              >
                TCP
              </DropdownItem>
            </DropdownMenu>
          </ButtonDropdown>
          </div>
          <div style={{display:"flex"}}>
            <Label for="implementation">DTN Implementation:</Label>
            <ButtonDropdown
            isOpen={this.state.nodeImplementationDropdownToggle}
            toggle={this.nodeImplementationDropdownToggle}
          >
            <DropdownToggle caret className="modal_action_dropdown">
              {this.state.implementation === ""
                    ? "Select"
                    : this.state.implementation}
            </DropdownToggle>
            <DropdownMenu right className="dropdown_menu">
              <DropdownItem
                className="dropdown_item"
                key="ion_impl"
                onClick={() => {
                  this.setState({implementation: "ION"})
                }}
              >
                ION
              </DropdownItem>
              <DropdownItem
                className="dropdown_item"
                key="ud3tn_impl"
                onClick={() => {
                  this.setState({implementation: "uD3TN"})
                }}
              >
                µD3TN
              </DropdownItem>
              { isStaff ?
              <DropdownItem
                className="dropdown_item"
                key="hdtn_impl"
                onClick={() => {
                  this.setState({implementation: "HDTN"})
                }}
              >
                HDTN
              </DropdownItem>
              :<></> }
            </DropdownMenu>
          </ButtonDropdown>
          </div>
        </ModalBody>
        <ModalFooter>
          {this.state.adding ? null : (
            <button
              className={`api_button ${this.state.apiModal ? "active" : null}`}
              onClick={() => {
                if (this.validateInput()) {
                  this.setState({ apiModal: !this.state.apiModal });
                }
              }}
            >
              API Call
            </button>
          )}
          <button
            className="save_button"
            disabled={this.state.loading}
            onClick={async () => {
              if (this.validateInput()) {
                await this.setState({ loading: true });
                if (this.state.UnknownIPCheck) {
                  const activeItem = {
                    ...this.state.activeItem,
                    public_ip: "Unknown",
                  };
                  await this.setState({ activeItem });
                }
                if(this.state.newCL){
                  const activeItem = {
                    ...this.state.activeItem,
                    convergence_layer: this.state.convergence_layer,
                  };
                  await this.setState({ activeItem });
                }
                if(this.state.newImplementation){
                  const activeItem = {
                    ...this.state.activeItem,
                    implementation: this.state.implementation,
                  };
                  await this.setState({ activeItem });
                }

                let valid = await onSave(
                  this.state.activeItem,
                  this.state.AMICheck
                );
                if (!valid) {
                  this.setState({ isValid: valid });
                  await this.setState({ validationErrors: getErrors() });
                  this.setState({ loading: false });
                }
              }
            }}
          >
            {this.state.loading ? (
              "Loading..."
            ) : (
              <>{this.state.adding ? "Add Node" : "Submit Edit"}</>
            )}
          </button>
          {this.state.apiModal ? (
            <div className="generated_area">
              <h4 style={{ color: "#60f056" }}>API Call</h4>
              <p>Edit node attributes remotely with:</p>
              <code style={{ color: "white" }}>
                {`curl -X POST -F 'me=${this.props.token}' -F 'node=${this.state.activeItem.uuid}' -F  'new_public_ip=${this.state.activeItem.public_ip}' -F 'new_port=${this.state.activeItem.port}' ${this.props.baseUrl}/api/node-edit`}
              </code>
            </div>
          ) : null}
        </ModalFooter>
      </Modal>
    );
  }
}
